
























import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator'
import { Base } from '@/base';

@Component({
  name: 'TheTitlePage'
})
export default class TheTitlePage extends Base {
  @Prop({default: ''}) btnText;
  @Prop({default: ''}) customClass;
  @Prop({default: () => ({})}) action1;

  isMarketPlace = false
};
